<script>
    import Content from '@/services/Content'
    import validationMessages from '@/components/validations'
    import { required, numeric } from "vuelidate/lib/validators";
    import CKEditor from '@ckeditor/ckeditor5-vue';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    export default {
        components:{
            validationMessages,   ckeditor: CKEditor.component, flatPickr
        },
        data() {
            return {
              csrf_token: localStorage.getItem('csrf_token'),
                showModal: false,
                tryingToSubmit: false,
                submitted: false,
                event: {
                start_at: '',
                event_limit:null,
                user_limit: null,
                company_limit: null,
                location:'',
                toc: '',
              },
                title: "",
                content: "",
                image:"",
                file:null,
                content_type: "event", 
                image_removed: false,
                editor: ClassicEditor,
                editorData: '',
                datetimeconfig: {
                    enableTime: true,
                    time_24hr: true,
                    minuteIncrement: 1,
                    inline: true,
                    dateFormat: "Y-m-d H:i", 
                    minDate: new Date(), 
                },
                            
            };
        },
        
        validations: {

      title: { required },
      content: { required },
      image: { required },
      event: {
        start_at: { required },
        event_limit: { numeric },
        user_limit: { numeric },
        company_limit: { numeric },
        location: { required },
        toc: { required },
      },
},
    
        methods: {
            refreshBusinessData() { 
                this.$emit('refreshScreen') //event from parent
            },
      
async addBusinessEvent() {
    this.tryingToSubmit = true;
    this.submitted = true;
    this.$v.$touch(); // Trigger validations

    if (this.$v.$invalid) {
      this.tryingToSubmit = false;
      return;
    }

    const payload = {
        title: this.title,
        content: this.content,
        image:this.file,
        content_type: this.content_type,
        event: {
            start_at: this.event.start_at,
            location: this.event.location,
            user_limit: this.event.user_limit,
            event_limit: this.event.event_limit,
            company_limit: this.event.company_limit,
            toc: this.event.toc 
        }
    };
  
    Content.addBusinessNews(payload)
    .then(() => {
      this.successmsg("Business Event Created!");
      this.closeModal();
      this.refreshBusinessData();
    })
    .catch((error) => {
      const errorMsg = error.response?.data?.error || "Failed to create business event";
      this.failedmsg(errorMsg);
    })
    .finally(() => {
      this.tryingToSubmit = false;
    });
  },
            closeModal() {
                this.showModal = false;
            },
            selectFile(event) {
  if (this.image) {
    URL.revokeObjectURL(this.image); 
  }
  const file = event.target.files[0];
  this.file = file;
  this.image = URL.createObjectURL(file);
},
removeImage() {
      this.file = null;
      this.image = "";
      this.$refs['file-input'].reset()
      this.image_removed = true
    },
          

            resetProps() {
   this.submitted = false;
   this.title = '';
   this.content = '';
   this.image = '';
   this.file=null;
   if (this.image) URL.revokeObjectURL(this.image); 
   this.event = {
    start_at: '',
    event_limit: null,
    user_limit: null,
    company_limit: null,
    location:'',
    toc: '',
  };
},
        }
    };
</script>

<template>
    <b-modal id="add_business_event" size="lg" v-model="showModal" @hidden="resetProps" title="Add Business Event" title-class="font-18">
    <form @submit.prevent="addBusinessEvent">
        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Event Name" label-for="title" class="mb-3">
               <b-form-input v-model="title"></b-form-input>
               <validationMessages 
  v-if="submitted" 
  :fieldName="'Event Name'" 
  :validationName="$v.title">
</validationMessages>
            </b-form-group>
            <b-form-group label="Date and Time" label-for="start_at" class="mb-3">
            <flat-pickr
              v-model="event.start_at"
              :config="datetimeconfig"
              class="form-control mb-2"
              name="start_at"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Date and Time'"
              :validationName="$v.event.start_at"
            ></validationMessages>
          </b-form-group>
          <b-form-group label="Upload Image" label-for="image" class="mb-3 image-area">
               <img :src="image != '' ? image : require('@/assets/images/image_not_found.png')" alt="" width="150" class="img-thumbnail me-2" >
               <b-form-file @change="selectFile" ref="file-input" type="file" class="mt-3" plain accept="image/jpeg, image/png" ></b-form-file>
               <a v-if="image" class="remove-image" href="javascript:void(0);" @click="removeImage" style="display: inline;">&#215;</a>
               <validationMessages
              v-if="submitted"
              :fieldName="'Image'"
              :validationName="$v.image"
            ></validationMessages>
            </b-form-group>
</div>
<div class="col-md-6">
    <b-form-group label="Description" label-for="description" class="mb-3">
                <template>
                    <ckeditor :editor="editor" v-model="content"></ckeditor>
                </template>
                <validationMessages 
  v-if="submitted" 
  :fieldName="'Description'" 
  :validationName="$v.content">
</validationMessages>
</b-form-group>
<b-form-group label="Location" label-for="location" class="mb-3">
               <b-form-input v-model="event.location"></b-form-input>
               <validationMessages 
  v-if="submitted" 
  :fieldName="'Location'" 
  :validationName="$v.event.location">
</validationMessages>
            </b-form-group>
            <b-form-group label="Maximum Substription Limit" label-for="userLimit" class="mb-3">
               <b-form-input v-model="event.user_limit"></b-form-input>
               <validationMessages 
  v-if="submitted" 
  :fieldName="'User Limit'" 
  :validationName="$v.event.user_limit">
</validationMessages>
            </b-form-group>
            <b-form-group
            label="Maximum Per Company"
            label-for="companyLimit"
            class="mb-3"
          >
            <b-form-input v-model="event.company_limit"></b-form-input>
            <validationMessages
              v-if="submitted"
              :fieldName="'Company Limit'"
              :validationName="$v.event.company_limit"
            ></validationMessages>
          </b-form-group>
          <b-form-group label="Maximum Event Limit" label-for="eventLimit" class="mb-3">
    <b-form-input v-model="event.event_limit"></b-form-input>
    <validationMessages 
        v-if="submitted" 
        :fieldName="'Event Limit'" 
        :validationName="$v.event.event_limit">
    </validationMessages>
</b-form-group>
<b-form-group label="Terms and Conditions" label-for="toc" class="mb-3">
    <b-form-input v-model="event.toc"></b-form-input>
    <validationMessages 
        v-if="submitted" 
        :fieldName="'Terms and Conditions'" 
        :validationName="$v.event.toc">
    </validationMessages>
</b-form-group>

          </div>
        </div>
        <input type="hidden" name="content_type" v-model="content_type">
        <input type="hidden" name="csrf_token" v-model="csrf_token">
      </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="addBusinessEvent" :disabled="tryingToSubmit">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>
                Submit</b-button>
        </template>

    </b-modal>
</template>